import React from 'react';

const Checkbox = ({ 
  label, 
  name, 
  checked, 
  onChange, 
  error,
  disabled = false,
  className = '' 
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            id={name}
            name={name}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={`
              custom-checkbox
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
            `}
          />
        </div>
        <div className="ml-3 text-sm">
          <label 
            htmlFor={name} 
            className={`
              text-gray-700 select-none
              ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
            `}
          >
            {label}
          </label>
        </div>
      </div>
      {error && (
        <div className="flex items-start mt-1.5 ml-8">
          <svg className="h-4 w-4 text-red-500 mr-1 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}
    </div>
  );
};

export default Checkbox;